export default {"src":"/_next/static/media/gmt.4a985405.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};